import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/AdminLayout';
import { authService } from '../../services/authService';

const AdminSettings = () => {
    const [activeTab, setActiveTab] = useState('profile');
    const [loading, setLoading] = useState(false);
    
    // Profile form state
    const [profileForm, setProfileForm] = useState({
        name: '',
        email: ''
    });

    // Password form state
    const [passwordForm, setPasswordForm] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    useEffect(() => {
        loadAdminProfile();
    }, []);

    const loadAdminProfile = () => {
        const admin = authService.getCurrentAdmin();
        if (admin) {
            setProfileForm({
                name: admin.name || 'Admin',
                email: admin.email || ''
            });
        }
    };

    const handleProfileChange = (e) => {
        const { name, value } = e.target;
        setProfileForm(prev => ({ ...prev, [name]: value }));
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordForm(prev => ({ ...prev, [name]: value }));
    };

    const handleProfileSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            // TODO: Implement profile update API call
            // await authService.updateProfile(profileForm);
            alert('Profile updated successfully!');
        } catch (err) {
            console.error('Error updating profile:', err);
            alert('Error updating profile. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        
        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            alert('New password and confirm password do not match!');
            return;
        }

        if (passwordForm.newPassword.length < 6) {
            alert('Password must be at least 6 characters long!');
            return;
        }

        try {
            setLoading(true);
            // TODO: Implement password change API call
            // await authService.changePassword(passwordForm);
            alert('Password changed successfully!');
            setPasswordForm({
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            });
        } catch (err) {
            console.error('Error changing password:', err);
            alert('Error changing password. Please check your current password.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AdminLayout>
            <div>
                {/* Header Section */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '40px'
                }}>
                    <div>
                        <h1 style={{
                            fontSize: '32px',
                            fontWeight: '300',
                            color: 'var(--text-light)',
                            marginBottom: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <span style={{ fontSize: '36px' }}>⚙️</span>
                            Settings
                        </h1>
                        <p style={{
                            fontSize: '14px',
                            color: 'rgba(245, 241, 237, 0.6)'
                        }}>
                            Manage your account settings and preferences
                        </p>
                    </div>
                </div>

                {/* Tabs */}
                <div style={{
                    display: 'flex',
                    gap: '12px',
                    marginBottom: '30px',
                    borderBottom: '1px solid rgba(201, 169, 110, 0.2)',
                    paddingBottom: '0'
                }}>
                    <button
                        onClick={() => setActiveTab('profile')}
                        style={{
                            padding: '12px 24px',
                            background: activeTab === 'profile' ? 'rgba(201, 169, 110, 0.1)' : 'transparent',
                            border: 'none',
                            borderBottom: activeTab === 'profile' ? '2px solid var(--accent-color)' : '2px solid transparent',
                            color: activeTab === 'profile' ? 'var(--accent-color)' : 'rgba(245, 241, 237, 0.6)',
                            fontSize: '15px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        👤 Profile
                    </button>
                    <button
                        onClick={() => setActiveTab('password')}
                        style={{
                            padding: '12px 24px',
                            background: activeTab === 'password' ? 'rgba(201, 169, 110, 0.1)' : 'transparent',
                            border: 'none',
                            borderBottom: activeTab === 'password' ? '2px solid var(--accent-color)' : '2px solid transparent',
                            color: activeTab === 'password' ? 'var(--accent-color)' : 'rgba(245, 241, 237, 0.6)',
                            fontSize: '15px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        🔒 Password
                    </button>
                </div>

                {/* Profile Tab */}
                {activeTab === 'profile' && (
                    <div style={{
                        background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.08) 0%, rgba(201, 169, 110, 0.03) 100%)',
                        border: '1px solid rgba(201, 169, 110, 0.2)',
                        borderRadius: '16px',
                        padding: '40px'
                    }}>
                        <h2 style={{
                            fontSize: '20px',
                            fontWeight: '500',
                            color: 'var(--text-light)',
                            marginBottom: '8px'
                        }}>
                            Profile Information
                        </h2>
                        <p style={{
                            fontSize: '14px',
                            color: 'rgba(245, 241, 237, 0.6)',
                            marginBottom: '30px'
                        }}>
                            Update your account profile information
                        </p>

                        <form onSubmit={handleProfileSubmit}>
                            <div style={{ maxWidth: '600px' }}>
                                {/* Name Field */}
                                <div style={{ marginBottom: '24px' }}>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: 'var(--text-light)'
                                    }}>
                                        Full Name *
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={profileForm.name}
                                        onChange={handleProfileChange}
                                        required
                                        placeholder="Enter your full name"
                                        style={{
                                            width: '100%',
                                            padding: '14px 18px',
                                            background: 'rgba(255, 255, 255, 0.05)',
                                            border: '1px solid rgba(201, 169, 110, 0.2)',
                                            borderRadius: '10px',
                                            color: 'var(--text-light)',
                                            fontSize: '15px',
                                            outline: 'none',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = 'var(--accent-color)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = 'rgba(201, 169, 110, 0.2)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                                        }}
                                    />
                                </div>

                                {/* Email Field */}
                                <div style={{ marginBottom: '30px' }}>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: 'var(--text-light)'
                                    }}>
                                        Email Address *
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={profileForm.email}
                                        onChange={handleProfileChange}
                                        required
                                        placeholder="Enter your email address"
                                        style={{
                                            width: '100%',
                                            padding: '14px 18px',
                                            background: 'rgba(255, 255, 255, 0.05)',
                                            border: '1px solid rgba(201, 169, 110, 0.2)',
                                            borderRadius: '10px',
                                            color: 'var(--text-light)',
                                            fontSize: '15px',
                                            outline: 'none',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = 'var(--accent-color)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = 'rgba(201, 169, 110, 0.2)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                                        }}
                                    />
                                </div>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    disabled={loading}
                                    style={{
                                        padding: '14px 32px',
                                        background: loading ? 'rgba(201, 169, 110, 0.3)' : 'linear-gradient(135deg, var(--accent-color) 0%, #B8935D 100%)',
                                        border: 'none',
                                        borderRadius: '10px',
                                        color: '#000',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        cursor: loading ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.3s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!loading) {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 8px 25px rgba(201, 169, 110, 0.4)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                >
                                    {loading ? <>⏳ Saving...</> : <>✓ Save Changes</>}
                                </button>
                            </div>
                        </form>
                    </div>
                )}

                {/* Password Tab */}
                {activeTab === 'password' && (
                    <div style={{
                        background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.08) 0%, rgba(201, 169, 110, 0.03) 100%)',
                        border: '1px solid rgba(201, 169, 110, 0.2)',
                        borderRadius: '16px',
                        padding: '40px'
                    }}>
                        <h2 style={{
                            fontSize: '20px',
                            fontWeight: '500',
                            color: 'var(--text-light)',
                            marginBottom: '8px'
                        }}>
                            Change Password
                        </h2>
                        <p style={{
                            fontSize: '14px',
                            color: 'rgba(245, 241, 237, 0.6)',
                            marginBottom: '30px'
                        }}>
                            Ensure your account is using a strong and secure password
                        </p>

                        <form onSubmit={handlePasswordSubmit}>
                            <div style={{ maxWidth: '600px' }}>
                                {/* Current Password */}
                                <div style={{ marginBottom: '24px' }}>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: 'var(--text-light)'
                                    }}>
                                        Current Password *
                                    </label>
                                    <input
                                        type="password"
                                        name="currentPassword"
                                        value={passwordForm.currentPassword}
                                        onChange={handlePasswordChange}
                                        required
                                        placeholder="Enter your current password"
                                        style={{
                                            width: '100%',
                                            padding: '14px 18px',
                                            background: 'rgba(255, 255, 255, 0.05)',
                                            border: '1px solid rgba(201, 169, 110, 0.2)',
                                            borderRadius: '10px',
                                            color: 'var(--text-light)',
                                            fontSize: '15px',
                                            outline: 'none',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = 'var(--accent-color)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = 'rgba(201, 169, 110, 0.2)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                                        }}
                                    />
                                </div>

                                {/* New Password */}
                                <div style={{ marginBottom: '24px' }}>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: 'var(--text-light)'
                                    }}>
                                        New Password *
                                    </label>
                                    <input
                                        type="password"
                                        name="newPassword"
                                        value={passwordForm.newPassword}
                                        onChange={handlePasswordChange}
                                        required
                                        placeholder="Enter your new password"
                                        style={{
                                            width: '100%',
                                            padding: '14px 18px',
                                            background: 'rgba(255, 255, 255, 0.05)',
                                            border: '1px solid rgba(201, 169, 110, 0.2)',
                                            borderRadius: '10px',
                                            color: 'var(--text-light)',
                                            fontSize: '15px',
                                            outline: 'none',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = 'var(--accent-color)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = 'rgba(201, 169, 110, 0.2)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                                        }}
                                    />
                                    <p style={{
                                        fontSize: '12px',
                                        color: 'rgba(245, 241, 237, 0.5)',
                                        marginTop: '6px'
                                    }}>
                                        Password must be at least 6 characters long
                                    </p>
                                </div>

                                {/* Confirm Password */}
                                <div style={{ marginBottom: '30px' }}>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: 'var(--text-light)'
                                    }}>
                                        Confirm New Password *
                                    </label>
                                    <input
                                        type="password"
                                        name="confirmPassword"
                                        value={passwordForm.confirmPassword}
                                        onChange={handlePasswordChange}
                                        required
                                        placeholder="Confirm your new password"
                                        style={{
                                            width: '100%',
                                            padding: '14px 18px',
                                            background: 'rgba(255, 255, 255, 0.05)',
                                            border: '1px solid rgba(201, 169, 110, 0.2)',
                                            borderRadius: '10px',
                                            color: 'var(--text-light)',
                                            fontSize: '15px',
                                            outline: 'none',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.borderColor = 'var(--accent-color)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = 'rgba(201, 169, 110, 0.2)';
                                            e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                                        }}
                                    />
                                </div>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    disabled={loading}
                                    style={{
                                        padding: '14px 32px',
                                        background: loading ? 'rgba(201, 169, 110, 0.3)' : 'linear-gradient(135deg, var(--accent-color) 0%, #B8935D 100%)',
                                        border: 'none',
                                        borderRadius: '10px',
                                        color: '#000',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        cursor: loading ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.3s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!loading) {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 8px 25px rgba(201, 169, 110, 0.4)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                >
                                    {loading ? <>⏳ Updating...</> : <>🔒 Update Password</>}
                                </button>
                            </div>
                        </form>
                    </div>
                )}
            </div>
        </AdminLayout>
    );
};

export default AdminSettings;

